export function convertPhoneNumber(phoneNumber) {
    if (/^0/.test(phoneNumber)) {
        return phoneNumber.replace(/^0/, "+84");
    } else if (/^(\+84|84)/.test(phoneNumber)) {
        return phoneNumber.replace(/^(84|\+84)/, "+84");
    } else {
        return phoneNumber;
    }
}